import React, { FC } from "react";

export interface PricesProps {
  className?: string;
  price?: number;
  contentClass?: string;
}

const Prices: FC<PricesProps> = ({
  className = "",
  price = 33,
  contentClass = "py-1 px-2 md:py-1.5 md:px-2.5 text-sm font-medium",
}) => {
  return (
    <div className={`${className}`}>
      <div
        className={`flex items-center border border-[#8672c7] rounded-lg whitespace-nowrap ${contentClass}`}
      >
        <span className="text-[#8672c7] !leading-none">
        ₹ {price?.toFixed(0)}.00 
          {/* AED {price} */}
        </span>
      </div>
    </div>
  );
};

export default Prices;
